// Game Configuration Constants
export const GAME_CONFIG = {
    // Canvas and Grid
    CANVAS_WIDTH: 600,
    CANVAS_HEIGHT: 400,
    GRID_SIZE: 20,
    
    // Game Speed
    INITIAL_SPEED: 150, // milliseconds per frame
    SPEED_INCREMENT: 5, // speed increase per level
    MIN_SPEED: 80, // minimum speed limit
    
    // Scoring
    FOOD_SCORE: 10,
    POWERUP_SCORE: 50,
    LEVEL_UP_SCORE: 100, // score needed to increase level
    
    // Power-up Duration (in milliseconds)
    POWERUP_DURATION: 8000, // 8 seconds
    
    // Power-up Spawn Rates
    POWERUP_SPAWN_CHANCE: 0.15, // 15% chance per food spawn
    
    // Mobile Controls
    SWIPE_THRESHOLD: 50, // minimum swipe distance
    TOUCH_DEADZONE: 20, // prevent accidental touches
};

// Grassline Brand Colors
export const COLORS = {
    // Snake Colors (different paint types)
    PAINT_WHITE: '#FFFFFF',
    PAINT_YELLOW: '#FFC107',
    PAINT_RED: '#F44336',
    PAINT_BLUE: '#2196F3',
    PAINT_GREEN: '#4CAF50',
    PAINT_ORANGE: '#FF9800',
    
    // Background Colors
    PITCH_GREEN: '#2E7D32',
    PITCH_DARK: '#1B5E20',
    LINE_WHITE: '#FFFFFF',
    
    // UI Colors
    UI_GREEN: '#4CAF50',
    UI_DARK_GREEN: '#2E7D32',
    UI_ACCENT: '#81C784',
    
    // Power-up Colors
    POWERUP_GLOW: '#FFD700',
    POWERUP_BACKGROUND: 'rgba(255, 215, 0, 0.3)',
};

// Power-up Types
export const POWERUP_TYPES = {
    MULTIPLIER_2X: {
        id: 'multiplier_2x',
        name: 'Red Paint',
        color: COLORS.PAINT_RED,
        multiplier: 2,
        score: GAME_CONFIG.POWERUP_SCORE,
        duration: GAME_CONFIG.POWERUP_DURATION,
        icon: '🔴'
    },
    MULTIPLIER_3X: {
        id: 'multiplier_3x',
        name: 'Blue Paint',
        color: COLORS.PAINT_BLUE,
        multiplier: 3,
        score: GAME_CONFIG.POWERUP_SCORE,
        duration: GAME_CONFIG.POWERUP_DURATION,
        icon: '🔵'
    },
    MULTIPLIER_5X: {
        id: 'multiplier_5x',
        name: 'Yellow Paint',
        color: COLORS.PAINT_YELLOW,
        multiplier: 5,
        score: GAME_CONFIG.POWERUP_SCORE,
        duration: GAME_CONFIG.POWERUP_DURATION,
        icon: '🟡'
    },
    COLOR_CHANGE: {
        id: 'color_change',
        name: 'Rainbow Paint',
        colors: [COLORS.PAINT_RED, COLORS.PAINT_BLUE, COLORS.PAINT_YELLOW, COLORS.PAINT_GREEN, COLORS.PAINT_ORANGE],
        score: GAME_CONFIG.POWERUP_SCORE,
        duration: GAME_CONFIG.POWERUP_DURATION,
        icon: '🌈'
    }
};

// Game States
export const GAME_STATES = {
    MENU: 'menu',
    PLAYING: 'playing',
    PAUSED: 'paused',
    GAME_OVER: 'game_over'
};

// Directions
export const DIRECTIONS = {
    UP: { x: 0, y: -1 },
    DOWN: { x: 0, y: 1 },
    LEFT: { x: -1, y: 0 },
    RIGHT: { x: 1, y: 0 }
};

// Keyboard Keys
export const KEYS = {
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    W: 'KeyW',
    A: 'KeyA',
    S: 'KeyS',
    D: 'KeyD',
    SPACE: 'Space',
    ESCAPE: 'Escape',
    ENTER: 'Enter'
};

// Local Storage Keys
export const STORAGE_KEYS = {
    HIGH_SCORE: 'grassline_snake_high_score',
    LEADERBOARD: 'grassline_snake_leaderboard',
    SETTINGS: 'grassline_snake_settings'
};

// Sound Effects (placeholder for future implementation)
export const SOUNDS = {
    EAT_FOOD: 'eat_food',
    EAT_POWERUP: 'eat_powerup',
    GAME_OVER: 'game_over',
    LEVEL_UP: 'level_up',
    POWERUP_ACTIVATE: 'powerup_activate'
};

// Pitch Field Markings (for background rendering)
export const PITCH_MARKINGS = {
    CENTER_LINE: {
        x: GAME_CONFIG.CANVAS_WIDTH / 2,
        y: 0,
        width: 2,
        height: GAME_CONFIG.CANVAS_HEIGHT
    },
    CENTER_CIRCLE: {
        x: GAME_CONFIG.CANVAS_WIDTH / 2,
        y: GAME_CONFIG.CANVAS_HEIGHT / 2,
        radius: 60
    },
    GOAL_AREAS: [
        {
            x: 0,
            y: GAME_CONFIG.CANVAS_HEIGHT / 2 - 40,
            width: 80,
            height: 80
        },
        {
            x: GAME_CONFIG.CANVAS_WIDTH - 80,
            y: GAME_CONFIG.CANVAS_HEIGHT / 2 - 40,
            width: 80,
            height: 80
        }
    ]
};

// Animation Settings
export const ANIMATIONS = {
    SNAKE_MOVEMENT: {
        duration: 100,
        easing: 'ease-in-out'
    },
    POWERUP_GLOW: {
        duration: 1000,
        pulse: true
    },
    SCORE_FLASH: {
        duration: 300,
        color: COLORS.POWERUP_GLOW
    }
};

// Mobile Touch Settings
export const TOUCH_CONFIG = {
    MIN_SWIPE_DISTANCE: 30,
    MAX_TAP_TIME: 300,
    DOUBLE_TAP_DELAY: 300
};
